import { render, staticRenderFns } from "./CreateQuestion.vue?vue&type=template&id=0134c2ae&scoped=true&"
import script from "./CreateQuestion.vue?vue&type=script&lang=js&"
export * from "./CreateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuestion.vue?vue&type=style&index=0&id=0134c2ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134c2ae",
  null
  
)

export default component.exports